import type { PlaybooksPanel } from '@atlassian/jira-playbooks-agent-view/src/ui/playbook-panel/index.tsx';
import { lazyForPaint } from '@atlassian/react-loosely-lazy';

export const AsyncPlaybooksPanel = lazyForPaint<typeof PlaybooksPanel>(() =>
	import(
		/* webpackChunkName: "async-jira-playbooks-agent-view" */ '@atlassian/jira-playbooks-agent-view/src/ui/playbook-panel'
	).then((module) => ({ default: module.PlaybooksPanel })),
);
